import * as React from 'react';
export const SCSvg = React.forwardRef(function SCSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M2 2h3L.358 13.142A1.99 1.99 0 0 1 0 12V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 2h6L.56 13.389a2.01 2.01 0 0 1-.202-.247L5 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 2h6L.56 13.389a2.01 2.01 0 0 1-.202-.247L5 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'm11 2-.917 1h-5.5L5 2z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M16 6v4L.555 13.382a2.005 2.005 0 0 1-.339-.477L16 6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        fillRule: 'nonzero',
        d: 'M16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-1.758-1.045L16 10v2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M16 6v4l-1 .156V6.438z',
      }),
    ),
  );
});
SCSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SC = {
  category: 'flag',
  colorable: false,
  name: 'SC',
  svg: SCSvg,
};
